<template>
    <div class="module-not container text-hint" v-if="!exist">{{ $t("Placeholder.UncollectedData") }}</div>
    <div :class="css.container" class="container" ref="container" v-loading="loading" v-else>
        <!-- * 柱状图 -->
        <div :class="css.canvas" v-if="statistics.length">
            <!-- * 图例 -->
            <div :class="css.tag">{{ $t("Publications", 2) }}</div>
            <!-- * 可视化图表 -->
            <div ref="canvas"></div>
        </div>

        <!-- * 控制器 -->
        <div :class="css.controls">
            <!-- * 日期选择器 -->
            <ui-select v-if="selectors.length" :class="css.selector" v-model="date" :candidates="selectors" @change="methods.selector" />

            <!-- * 多选选择器 -->
            <ui-checkbox-group v-model="tags" :class="css.checkboxs" @change="methods.acquire(1)">
                <ui-checkbox v-for="value in checkboxs" :class="css.checkbox" :value="value.value" :disabled="value.number == 0">
                    {{ value.name }} ({{ value.number }})
                </ui-checkbox>
            </ui-checkbox-group>
        </div>

        <!-- * 表格 -->
        <ui-table2 ref="table" :data="data" :error="$t('NoData')" :option="options.table" @sort="methods.sort">
            <template #id="{ data }">
                <template v-if="!data.id">--</template>
                <template v-else>
                    <ProjectRoute :class="css_normalize.assets" :to="`https://pubmed.ncbi.nlm.nih.gov/${data.id}`">{{ data.id }}</ProjectRoute>
                </template>
            </template>

            <template #name="{ data }">
                <ui-tooltip :class-extra-name="css.view" direction="bottom">
                    <div :class="css_normalize.assets" style="cursor: default" v-html="data.name"></div>
                    <template #content>
                        <div :class="css.name" class="color-1 font-bold">{{ $t("Abstract") }}:</div>
                        <div :class="css.content" v-html="data.abstract"></div>
                    </template>
                </ui-tooltip>
            </template>
        </ui-table2>

        <!-- * 分页器 -->
        <ui-pagination v-model="page" :class="css.pagination" :count="count" @change="methods.acquire()">
            <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: 10 }) }}</template>
        </ui-pagination>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTable2, UiSelect, UiCheckbox, UiTooltip, UiPagination, UiCheckboxGroup } from "various-ui";
//* 组件属性
import { ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组件属性注册
const define = defineProps(ModulePropsOption);

//* 组合函数
const { refs, nodes, methods, options } = useComposable(define);
const { page, date, tags, data, count, loading, selectors, checkboxs, statistics, exist } = refs;
const { table, canvas, container } = nodes;

//* 组件挂载时获取数据
onMounted(() => methods.acquire(1));
</script>
